import { useState, useEffect } from 'react';
import { Calendar, MapPin, ArrowRight } from 'lucide-react';
import { eventsAPI } from '@/lib/api';

const Events = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await eventsAPI.getAll();
        // Show only active events, limit to 3 most recent
        setEvents(response.data.filter(e => e.is_active).slice(0, 3));
      } catch (error) {
        console.error('Failed to fetch events:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, []);

  if (loading || events.length === 0) {
    return null;
  }

  return (
    <section className="py-20 bg-gradient-to-b from-[#121212] to-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-light text-white mb-4">
            رویدادهای <span className="text-[#D4AF37]">پیش رو</span>
          </h2>
          <p className="text-lg text-zinc-400">
            در سمینارها و رویدادهای آموزشی ما شرکت کنید
          </p>
        </div>

        {/* Events Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {events.map((event) => {
            // Handle relative URLs
            const eventImageUrl = event.image_url?.startsWith('http')
              ? event.image_url
              : `${process.env.REACT_APP_BACKEND_URL}${event.image_url}`;
            
            return (
              <div
                key={event.id}
                className="glass-effect border border-white/10 rounded-2xl overflow-hidden hover:border-[#D4AF37]/30 transition-all group"
              >
                {/* Event Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={eventImageUrl}
                    alt={event.title_fa}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
              </div>

              {/* Event Info */}
              <div className="p-6">
                <h3 className="text-xl font-semibold text-white mb-3 group-hover:text-[#D4AF37] transition-colors">
                  {event.title_fa}
                </h3>
                <p className="text-sm text-zinc-400 mb-4 line-clamp-2">
                  {event.description_fa}
                </p>

                {/* Date & Location */}
                <div className="space-y-2 mb-4">
                  <div className="flex items-center gap-2 text-sm text-zinc-500">
                    <Calendar size={16} className="text-[#D4AF37]" />
                    <span>{event.event_date}</span>
                  </div>
                  <div className="flex items-center gap-2 text-sm text-zinc-500">
                    <MapPin size={16} className="text-[#D4AF37]" />
                    <span>{event.location}</span>
                  </div>
                </div>

                {/* CTA */}
                <button className="flex items-center gap-2 text-[#D4AF37] text-sm font-medium group-hover:gap-3 transition-all">
                  اطلاعات بیشتر
                  <ArrowRight size={16} className="rotate-180" />
                </button>
              </div>
            </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Events;
